import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';

export type StatusChipColor =
  | 'emerald'
  | 'blue'
  | 'orange'
  | 'purple'
  | 'cyan'
  | 'indigo'
  | 'teal'
  | 'red'
  | 'green'
  | 'amber'
  | 'violet'
  | 'gray';

interface StatusChipProps {
  label: string;
  color: StatusChipColor;
  tooltip?: string;
}

const colorClassMap: Record<StatusChipColor, string> = {
  emerald: '!bg-emerald-100 !text-emerald-800',
  blue: '!bg-blue-100 !text-blue-800',
  orange: '!bg-orange-100 !text-orange-800',
  purple: '!bg-purple-100 !text-purple-800',
  cyan: '!bg-cyan-100 !text-cyan-800',
  indigo: '!bg-indigo-100 !text-indigo-800',
  teal: '!bg-teal-100 !text-teal-800',
  red: '!bg-red-100 !text-red-800',
  green: '!bg-green-100 !text-green-800',
  amber: '!bg-amber-100 !text-amber-800',
  violet: '!bg-violet-100 !text-violet-800',
  gray: '!bg-gray-100 !text-gray-800'
};

const StatusChip: React.FC<StatusChipProps> = ({ label, color, tooltip }) => {
  const chip = <Chip size="small" label={label} className={colorClassMap[color]} />;

  if (tooltip) {
    return (
      <Tooltip arrow title={tooltip}>
        <span className="cursor-help">{chip}</span>
      </Tooltip>
    );
  }

  return chip;
};

export default StatusChip;
